<div class="login-page-container">
  <!-- Background Product Gallery -->
  <div class="product-gallery-background">
    <div class="product-grid">
      <div *ngFor="let producto of arrProductos" class="product-card">
        <img [src]="producto.ImagenUrl" [alt]="producto.Nombre" class="product-image">
        <div class="product-name">{{ producto.Nombre }}</div>
      </div>
    </div>
    <div class="overlay"></div>
  </div>

  <!-- Centered container for login/register content -->
  <div class="center-container">

    <!-- Initial Selection Modal -->
    <div class="selection-modal" *ngIf="formToShow === 'none'">
      <div class="modal-content">
        <img src="assets/images/logo-huapango.png" alt="Logo" class="logo" style="">
        <h2>Tienda Mayorista</h2>
        <p>Seleccione una opción para continuar</p>
        <div class="modal-buttons">
          <button class="primary" (click)="showLoginForm()">Iniciar Sesión</button>
          <button class="secondary" (click)="showRegisterForm()">Crear Cuenta</button>
          <button class="secondary" (click)="showTiendaNubeForm()">Web Minorista</button>
        </div>
      </div>
    </div>

    <!-- Login Form -->
    <div class="login-form" *ngIf="formToShow === 'login'">
      <div class="login-form-content">
        <form (submit)="onSubmit($event)">
          <img src="assets/images/logo-huapango.png" alt="Logo" class="logo">
          <div class="auth-intro">
            <h2>¡Bienvenido!</h2>
            <p>Inicia sesión para continuar.</p>
          </div>

          <dx-form [formData]="formData" [disabled]="loading">
            <dxi-item dataField="email" editorType="dxTextBox" [editorOptions]="{ stylingMode: 'filled', placeholder: 'Email', mode: 'email' }">
              <dxi-validation-rule type="required" message="Email es requerido"></dxi-validation-rule>
              <dxi-validation-rule type="email" message="Email no es válido"></dxi-validation-rule>
              <dxo-label [visible]="false"></dxo-label>
            </dxi-item>

            <dxi-item dataField="password" editorType="dxTextBox" [editorOptions]="{ stylingMode: 'filled', placeholder: 'Contraseña', mode: 'password' }">
              <dxi-validation-rule type="required" message="Contraseña es requerida"></dxi-validation-rule>
              <dxo-label [visible]="false"></dxo-label>
            </dxi-item>

            <dxi-item itemType="button" [buttonOptions]="buttonOptions" [template]="'signInTemplate'">
            </dxi-item>

            <dxi-item>
              <div class="link">
                <a routerLink="/reset-password">¿Olvidó la Clave?</a>
              </div>
            </dxi-item>

            <div *ngIf="errorMessage" class="error-message">
              {{ errorMessage }}
            </div>

            <dxi-item>
              <div class='policy-info'>
                <span>¿No está registrado? <a (click)="showRegisterForm()">Crear una cuenta</a></span>
                <span class="separator">|</span>
                <a (click)="showChoice()">Volver</a>
              </div>
            </dxi-item>

            <ng-container *dxTemplate="let item of 'signInTemplate'">
              <span class="dx-button-text">
                <ng-container *ngIf="loading; else notLoading">
                  <dx-load-indicator width="24px" height="24px" [visible]="true"></dx-load-indicator>
                </ng-container>
                <ng-template #notLoading>Acceder</ng-template>
              </span>
            </ng-container>
          </dx-form>
        </form>
      </div>
    </div>

    

  </div>
</div>
